<div [formGroup]="form" class="popupview">
    <h2>Reglas</h2>
    <div class="popup-mid">
        <div class="block">
            <mat-label>Regla</mat-label>
        <mat-form-field appearance="fill">
            
            <mat-select formControlName="tipoReglaId" (selectionChange)="onRuleTypeChanges()">
                <mat-option *ngFor="let option of ruleTypes" [value]="option.tipoReglaId">
                    {{option.regla}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-error *ngIf="form.controls.tipoReglaId.touched && form.controls.tipoReglaId.errors">
            Obligatorio
        </mat-error>
        </div>

        <div class="w100">

        <div class="block w50" *ngIf="!form.controls.parametro1.disabled">
            <mat-label>Parametro 1</mat-label>
            <div>
            <mat-form-field class="example-full-width w25 parametro-disable" appearance="fill">
                
                <input matInput formControlName="parametro1" readonly>
            </mat-form-field>
            <div class="w25">
            <mat-form-field class="example-full-width" appearance="fill">
                <input matInput formControlName="param1" type="number">
            </mat-form-field>
            <mat-error *ngIf="form.controls.param1.touched && form.controls.param1.errors">
                Obligatorio
            </mat-error>
        </div>
        </div>
        </div>

        <div class="block w50 fright" *ngIf="!form.controls.parametro2.disabled">
            <mat-label>Parametro 2</mat-label>
        <div >
            <mat-form-field class="example-full-width w25 parametro-disable" appearance="fill">
                
                <input matInput formControlName="parametro2" readonly>
            </mat-form-field>
            <div class="w25">
            <mat-form-field class="example-full-width" appearance="fill">
                <input matInput formControlName="param2" type="number">
            </mat-form-field>
            <mat-error *ngIf="form.controls.param2.touched && form.controls.param2.errors">
                Obligatorio
            </mat-error>
        </div>
        </div>
        </div>

    </div>

        <div class="block w50">
            <mat-label>Tarea</mat-label>
        <mat-form-field appearance="fill">
            
            <mat-select formControlName="tareaId">
                <mat-option [value]="1">Contacto</mat-option>
                <mat-option [value]="2">Citar</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-error *ngIf="form.controls.tareaId.touched && form.controls.tareaId.errors">
            Obligatorio
        </mat-error>
        </div>

        <div class="block w50 fright">
            <mat-label>Dias</mat-label>
        <mat-form-field class="example-full-width" appearance="fill">
            
            <input matInput formControlName="dias" type="number">
        </mat-form-field>
        <mat-error *ngIf="form.controls.dias.touched && form.controls.dias.errors">
            El máximo de días es 30
        </mat-error>
        </div>
    </div>  
    <div>
        <button class="cancel" (click)="close()"><span class="mat-button-wrapper">Cancelar</span></button>
        <button class="confirm" (click)="onCreateRule()"><span class="mat-button-wrapper">Confirmar</span></button>
    </div>
</div>

